/**
 * Determine the country from pickup point data
 * @param {Object} pickupPoint - Pickup point object from Packeta
 * @returns {string} - Country code ('cz' or 'sk')
 */
const getPickupPointCountry = (pickupPoint) => {
  // First, try to get the country directly from the point object
  if (pickupPoint.country) {
    return pickupPoint.country.toLowerCase();
  }
  
  // Fallback: determine country from postal code
  if (pickupPoint.zip) {
    const zip = pickupPoint.zip.toString().replace(/\s/g, '');
    
    // Slovak postal codes start with 8, 9, or 0
    if (zip.startsWith('8') || zip.startsWith('9') || zip.startsWith('0')) {
      return 'sk';
    }
    
    // Czech postal codes start with 1-7
    if (zip.startsWith('1') || zip.startsWith('2') || zip.startsWith('3') || 
        zip.startsWith('4') || zip.startsWith('5') || zip.startsWith('6') || zip.startsWith('7')) {
      return 'cz';
    }
  }
  
  // Fallback: determine country from city name (basic check)
  if (pickupPoint.city) {
    const city = pickupPoint.city.toLowerCase();
    
    // Common Slovak cities
    const slovakCities = ['bratislava', 'košice', 'žilina', 'nitra', 'trenčín', 'trnava', 'banská bystrica'];
    if (slovakCities.some(slovakCity => city.includes(slovakCity))) {
      return 'sk';
    }
  }
  
  // Default to Czech Republic if we can't determine
  console.warn('Could not determine pickup point country, defaulting to CZ:', pickupPoint);
  return 'cz';
};

export default getPickupPointCountry; 